var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSunny(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 23,
    viewBox: "0 0 22 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 4.5V0.5H12V4.5H10ZM16.65 7.25L15.275 5.875L18.075 3L19.475 4.425L16.65 7.25ZM18 12.5V10.5H22V12.5H18ZM10 22.5V18.5H12V22.5H10ZM5.35 7.2L2.5 4.425L3.925 3.025L6.75 5.85L5.35 7.2ZM18.05 20L15.275 17.125L16.625 15.775L19.475 18.525L18.05 20ZM0 12.5V10.5H4V12.5H0ZM3.925 20L2.525 18.575L5.325 15.775L6.05 16.45L6.775 17.15L3.925 20ZM11 17.5C9.33333 17.5 7.91667 16.9167 6.75 15.75C5.58333 14.5833 5 13.1667 5 11.5C5 9.83333 5.58333 8.41667 6.75 7.25C7.91667 6.08333 9.33333 5.5 11 5.5C12.6667 5.5 14.0833 6.08333 15.25 7.25C16.4167 8.41667 17 9.83333 17 11.5C17 13.1667 16.4167 14.5833 15.25 15.75C14.0833 16.9167 12.6667 17.5 11 17.5Z",
    fill: "#4FAAFF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSunny);
export default __webpack_public_path__ + "static/media/sunny.a2c892e11e74f435bbca30c948728a5b.svg";
export { ForwardRef as ReactComponent };